import React, { useEffect } from "react";
import useState from "react-usestateref";
import Header from "./Header";
import Sidebar from "./Sidebar";
import apiService from "../core/sevice/detail";
import {
  getMethod,
  postMethod,
} from "../core/sevice/common.api";
import toast, { Toaster } from "react-hot-toast";

function InvestmentSettings() {

    const initialFormValue = {
        baseorder_limit: "",
        buy_level1_limit: "",
        buy_level2_limit: "",
        buy_level3_limit: "",
        buy_level4_limit: "",
        buy_level5_limit: "",
        buy_level6_limit: "",
        buy_level1_percentage: "",
        buy_level2_percentage: "",
        buy_level3_percentage: "",
        buy_level4_percentage: "",
        buy_level5_percentage: "",
        buy_level6_percentage: "",
        profit_percentage_sell:"",
        profit_callback: "",
        levels_count: "",
        balance_lock: "",
        status: ""
        
      }

      const [validationnErr, setvalidationnErr] = useState("");
      const [formValue, setFormValue] = useState(initialFormValue);
      const [baseorder_limitValidate, setbaseorder_limitValidate,baseorder_limitValidateref] = useState(false);
      const [buy_level1_limitValidate, setbuy_level1_limitValidate,buy_level1_limitValidateref] = useState(false);
      const [buy_level2_limitValidate, setbuy_level2_limitValidate,buy_level2_limitValidateref] = useState(false);
      const [buy_level3_limitValidate, setbuy_level3_limitValidate,buy_level3_limitValidateref] = useState(false);
      const [buy_level4_limitValidate, setbuy_level4_limitValidate,buy_level4_limitValidateref] = useState(false);
      const [buy_level5_limitValidate, setbuy_level5_limitValidate,buy_level5_limitValidateref] = useState(false);
      const [buy_level6_limitValidate, setbuy_level6_limitValidate,buy_level6_limitValidateref] = useState(false);
      const [buy_level1_percentageValidate, setbuy_level1_percentageValidate,buy_level1_percentageValidateref] = useState(false);
      const [buy_level2_percentageValidate, setbuy_level2_percentageValidate,buy_level2_percentageValidateref] = useState(false);
      const [buy_level3_percentageValidate, setbuy_level3_percentageValidate,buy_level3_percentageValidateref] = useState(false);
      const [buy_level4_percentageValidate, setbuy_level4_percentageValidate,buy_level4_percentageValidateref] = useState(false);
      const [buy_level5_percentageValidate, setbuy_level5_percentageValidate,buy_level5_percentageValidateref] = useState(false);
      const [buy_level6_percentageValidate, setbuy_level6_percentageValidate,buy_level6_percentageValidateref] = useState(false);
      const [profit_percentage_sellValidate, setprofit_percentage_sellValidate,profit_percentage_sellValidateref] = useState(0);
      const [profit_callbackValidate, setprofit_callbackValidate,profit_callbackValidateref] = useState(0);
      const [levels_countValidate, setlevels_countValidate,levels_countValidateref] = useState(0);
      const [balance_lockValidate, setbalance_lockValidate,balance_lockValidateref] = useState(false);
      const [statusValidate, setstatusValidate,statusValidateref] = useState(false);

      const [isLoading, setIsLoading] = useState(false);
      const [buttonLoader, setbuttonLoader] = useState(false);

      
      const {
        baseorder_limit,
        buy_level1_limit,
        buy_level2_limit,
        buy_level3_limit,
        buy_level4_limit,
        buy_level5_limit,
        buy_level6_limit,
        buy_level1_percentage,
        buy_level2_percentage,
        buy_level3_percentage,
        buy_level4_percentage,
        buy_level5_percentage,
        buy_level6_percentage,
        profit_percentage_sell,
        profit_callback,
        levels_count,
        balance_lock,
        status
        

      } = formValue;

      useEffect(() => {
        getInvestment();
  
      }, [0]);
  
      const handleChange = async (e) => {
        e.preventDefault();
        const {name, value} = e.target;
        let formData = {...formValue, ...{[name]: value}};
        setFormValue(formData);
        validate(formData);
      };

      const validate = async (values) => {
        const errors = {};
  
        if (!values.baseorder_limit) {
          errors.baseorder_limit = "Required field !";
          setbaseorder_limitValidate(true);
        } else {
          setbaseorder_limitValidate(false);
        }
  
        if (!values.buy_level1_limit) {
          errors.buy_level1_limit = "Required field !";
          setbuy_level1_limitValidate(true);
        } else {
          setbuy_level1_limitValidate(false);
        }

        if (!values.buy_level2_limit) {
          errors.buy_level2_limit = "Required field !";
          setbuy_level2_limitValidate(true);
        } else {
          setbuy_level2_limitValidate(false);
        }


        if (!values.buy_level3_limit) {
          errors.buy_level3_limit = "Required field !";
          setbuy_level3_limitValidate(true);
        } else {
          setbuy_level3_limitValidate(false);
        }


        if (!values.buy_level4_limit) {
          errors.buy_level4_limit = "Required field !";
          setbuy_level4_limitValidate(true);
        } else {
          setbuy_level4_limitValidate(false);
        }

        if (!values.buy_level5_limit) {
            errors.buy_level5_limit = "Required field !";
            setbuy_level5_limitValidate(true);
          } else {
            setbuy_level5_limitValidate(false);
          }

          if (!values.buy_level6_limit) {
            errors.buy_level6_limit = "Required field !";
            setbuy_level6_limitValidate(true);
          } else {
            setbuy_level6_limitValidate(false);
          }


        if (!values.buy_level1_percentage) {
          errors.buy_level1_percentage = "Required field !";
          setbuy_level1_percentageValidate(true);
        } else {
          setbuy_level1_percentageValidate(false);
        }

        if (!values.buy_level2_percentage) {
          errors.buy_level2_percentage = "Required field !";
          setbuy_level2_percentageValidate(true);
        } else {
          setbuy_level2_percentageValidate(false);
        }


        if (!values.buy_level3_percentage) {
          errors.buy_level3_percentage = "Required field !";
          setbuy_level3_percentageValidate(true);
        } else {
          setbuy_level3_percentageValidate(false);
        }


        if (!values.buy_level4_percentage) {
          errors.buy_level4_percentage = "Required field !";
          setbuy_level4_percentageValidate(true);
        } else {
          setbuy_level4_percentageValidate(false);
        }

        if (!values.buy_level5_percentage) {
            errors.buy_level5_percentage = "Required field !";
            setbuy_level5_percentageValidate(true);
          } else {
            setbuy_level5_percentageValidate(false);
          }

          if (!values.buy_level6_percentage) {
            errors.buy_level6_percentage = "Required field !";
            setbuy_level6_percentageValidate(true);
          } else {
            setbuy_level6_percentageValidate(false);
          }

        if (!values.profit_percentage_sell) {
          errors.profit_percentage_sell = "Required field !";
          setprofit_percentage_sellValidate(true);
        }
        else {
          setprofit_percentage_sellValidate(false);
        }

        if (!values.profit_callback) {
            errors.profit_callback = "Required field !";
            setprofit_callbackValidate(true);
        }
        else {
            setprofit_callbackValidate(false);
        }

        if (!values.levels_count) {
          errors.levels_count = "Required field !";
          setlevels_countValidate(true);
        }
        else {
          setlevels_countValidate(false);
        }

        if (!values.balance_lock) {
          errors.balance_lock = "Required field !";
          setbalance_lockValidate(true);
        }
        else {
          setbalance_lockValidate(false);
        }


        if (values.status == "" || values.status == undefined ) {
            errors.status = "Required field !";
            setstatusValidate(true);
        }
        else {
            setstatusValidate(false);
        }


        setvalidationnErr(errors);
        return errors;
      }

      const getInvestment = async () => {
        try {
          var data = {
            apiUrl: apiService.getInvestment,
          };
          setIsLoading(true);
          var resp = await getMethod(data);
          
          if (resp.status == true) {
            setIsLoading(false);
            formValue.baseorder_limit = resp.data.baseorder_limit;
            formValue.buy_level1_limit = resp.data.buy_level1_limit;
            formValue.buy_level2_limit = resp.data.buy_level2_limit;
            formValue.buy_level3_limit = resp.data.buy_level3_limit;
            formValue.buy_level4_limit = resp.data.buy_level4_limit;
            formValue.buy_level5_limit = resp.data.buy_level5_limit;
            formValue.buy_level6_limit = resp.data.buy_level6_limit;
            formValue.buy_level1_percentage = resp.data.buy_level1_percentage;
            formValue.buy_level2_percentage = resp.data.buy_level2_percentage;
            formValue.buy_level3_percentage = resp.data.buy_level3_percentage;
            formValue.buy_level4_percentage = resp.data.buy_level4_percentage;
            formValue.buy_level5_percentage = resp.data.buy_level5_percentage;
            formValue.buy_level6_percentage = resp.data.buy_level6_percentage;
            formValue.profit_percentage_sell = resp.data.profit_percentage_sell;
            formValue.profit_callback = resp.data.profit_callback;
            formValue.levels_count = resp.data.levels_count;
            formValue.balance_lock = resp.data.balance_lock;
            formValue.status = resp.data.status;
          }
        } catch (error) {}
      };

      const formSubmit = async () => {
        validate(formValue);
        if (baseorder_limitValidateref.current === false && buy_level1_limitValidateref.current === false &&
            buy_level2_limitValidateref.current === false && buy_level2_limitValidateref.current === false &&
            buy_level3_limitValidateref.current === false && buy_level4_limitValidateref.current === false &&
            profit_percentage_sellValidateref.current === false && balance_lockValidateref.current === false &&
            statusValidateref.current === false
        ) {
          var data = {
            apiUrl: apiService.updateInvestment,
            payload: formValue,
          };
          setbuttonLoader(true);
          var resp = await postMethod(data);
            if(resp.status == true) {
                toast.success(resp.Message);
                getInvestment();
                setbuttonLoader(false);
            }
            else {
                setbuttonLoader(false);
                toast.error(resp.Message);
            }
        }
      };

  return (
    <div>
      <Toaster
        position="top-center"
        reverseOrder={false}
        toastOptions={{
          duration: 4000,
        }}
      />
      <Header />
      <div className="container-fluid enzo-wrapper">
        <div className="row">
        <div className="col-lg-2 pad-left-0 max-md-none bor-right max-d-none">
            <Sidebar />
          </div>
          <div className="col-lg-10 col-sm-9">
            <div className="container-fluid settings-container">
              {isLoading == true ? (
                <>
                  <div className="loader-css">
                    <img
                      src={require("../assets/loader.gif")}
                      alt="loader"
                      className="loader-gif"
                    />
                  </div>
                </>
              ) : (
                <>
                  <div className="row d-flex justify-content-center align-items-center">
                  <div className="col-lg-8">
                      <div className="setting_blw_col_title">Investment Settings</div>
                      <div className="setting_blw_col2">

                        <div className="input-settings">
                          <label>DCA Base Order Limit</label>
                          <input
                              type="number"
                              className="login-input mt-1"
                              name="baseorder_limit"
                              value={baseorder_limit}
                              onChange={handleChange}
                              min = "0"
                            />
                            {baseorder_limitValidate == true ? (
                                <p className="errorcss">
                                {" "}
                                {validationnErr.baseorder_limit}{" "}
                                </p>
                            ) : (
                                ""
                            )}
                        </div>

                        <div className="input-settings">
                          <label>DCA Level1 Order Limit</label>
                          <input
                              type="number"
                              className="login-input mt-1"
                              name="buy_level1_limit"
                              value={buy_level1_limit}
                              onChange={handleChange}
                              min = "0"
                            />
                            {buy_level1_limitValidate == true ? (
                                <p className="errorcss">
                                {" "}
                                {validationnErr.buy_level1_limit}{" "}
                                </p>
                            ) : (
                                ""
                            )}
                        </div>


                        <div className="input-settings">
                          <label>DCA Level2 Order Limit</label>
                          <input
                              type="number"
                              className="login-input mt-1"
                              name="buy_level2_limit"
                              value={buy_level2_limit}
                              onChange={handleChange}
                              min = "0"
                            />
                            {buy_level2_limitValidate == true ? (
                                <p className="errorcss">
                                {" "}
                                {validationnErr.buy_level2_limit}{" "}
                                </p>
                            ) : (
                                ""
                            )}
                        </div>

                        <div className="input-settings">
                          <label>DCA Level3 Order Limit</label>
                          <input
                              type="number"
                              className="login-input mt-1"
                              name="buy_level3_limit"
                              value={buy_level3_limit}
                              onChange={handleChange}
                              min = "0"
                            />
                            {buy_level3_limitValidate == true ? (
                                <p className="errorcss">
                                {" "}
                                {validationnErr.buy_level3_limit}{" "}
                                </p>
                            ) : (
                                ""
                            )}
                        </div>

                        <div className="input-settings">
                          <label>DCA Level4 Order Limit</label>
                          <input
                              type="number"
                              className="login-input mt-1"
                              name="buy_level4_limit"
                              value={buy_level4_limit}
                              onChange={handleChange}
                              min = "0"
                            />
                            {buy_level4_limitValidate == true ? (
                                <p className="errorcss">
                                {" "}
                                {validationnErr.buy_level4_limit}{" "}
                                </p>
                            ) : (
                                ""
                            )}
                        </div>


                        <div className="input-settings">
                          <label>DCA Level5 Order Limit</label>
                          <input
                              type="number"
                              className="login-input mt-1"
                              name="buy_level5_limit"
                              value={buy_level5_limit}
                              onChange={handleChange}
                              min = "0"
                            />
                            {buy_level5_limitValidate == true ? (
                                <p className="errorcss">
                                {" "}
                                {validationnErr.buy_level5_limit}{" "}
                                </p>
                            ) : (
                                ""
                            )}
                        </div>

                        <div className="input-settings">
                          <label>DCA Level6 Order Limit</label>
                          <input
                              type="number"
                              className="login-input mt-1"
                              name="buy_level6_limit"
                              value={buy_level6_limit}
                              onChange={handleChange}
                              min = "0"
                            />
                            {buy_level6_limitValidate == true ? (
                                <p className="errorcss">
                                {" "}
                                {validationnErr.buy_level6_limit}{" "}
                                </p>
                            ) : (
                                ""
                            )}
                        </div>


                        <div className="input-settings">
                          <label>DCA Level1 Buy Percentage</label>
                          <input
                              type="number"
                              className="login-input mt-1"
                              name="buy_level1_percentage"
                              value={buy_level1_percentage}
                              onChange={handleChange}
                              min = "0"
                            />
                            {buy_level1_percentageValidate == true ? (
                                <p className="errorcss">
                                {" "}
                                {validationnErr.buy_level1_percentage}{" "}
                                </p>
                            ) : (
                                ""
                            )}
                        </div>


                        <div className="input-settings">
                          <label>DCA Level2 Buy Percentage</label>
                          <input
                              type="number"
                              className="login-input mt-1"
                              name="buy_level2_percentage"
                              value={buy_level2_percentage}
                              onChange={handleChange}
                              min = "0"
                            />
                            {buy_level2_percentageValidate == true ? (
                                <p className="errorcss">
                                {" "}
                                {validationnErr.buy_level2_percentage}{" "}
                                </p>
                            ) : (
                                ""
                            )}
                        </div>

                        <div className="input-settings">
                          <label>DCA Level3 Buy Percentage</label>
                          <input
                              type="number"
                              className="login-input mt-1"
                              name="buy_level3_percentage"
                              value={buy_level3_percentage}
                              onChange={handleChange}
                              min = "0"
                            />
                            {buy_level3_percentageValidate == true ? (
                                <p className="errorcss">
                                {" "}
                                {validationnErr.buy_level3_percentage}{" "}
                                </p>
                            ) : (
                                ""
                            )}
                        </div>

                        <div className="input-settings">
                          <label>DCA Level4 Buy Percentage</label>
                          <input
                              type="number"
                              className="login-input mt-1"
                              name="buy_level4_percentage"
                              value={buy_level4_percentage}
                              onChange={handleChange}
                              min = "0"
                            />
                            {buy_level4_percentageValidate == true ? (
                                <p className="errorcss">
                                {" "}
                                {validationnErr.buy_level4_percentage}{" "}
                                </p>
                            ) : (
                                ""
                            )}
                        </div>

                        <div className="input-settings">
                          <label>DCA Level5 Buy Percentage</label>
                          <input
                              type="number"
                              className="login-input mt-1"
                              name="buy_level5_percentage"
                              value={buy_level5_percentage}
                              onChange={handleChange}
                              min = "0"
                            />
                            {buy_level5_percentageValidate == true ? (
                                <p className="errorcss">
                                {" "}
                                {validationnErr.buy_level5_percentage}{" "}
                                </p>
                            ) : (
                                ""
                            )}
                        </div>

                        <div className="input-settings">
                          <label>DCA Level6 Buy Percentage</label>
                          <input
                              type="number"
                              className="login-input mt-1"
                              name="buy_level6_percentage"
                              value={buy_level6_percentage}
                              onChange={handleChange}
                              min = "0"
                            />
                            {buy_level6_percentageValidate == true ? (
                                <p className="errorcss">
                                {" "}
                                {validationnErr.buy_level6_percentage}{" "}
                                </p>
                            ) : (
                                ""
                            )}
                        </div>

                        <div className="input-settings">
                          <label>DCA Sell Profit Percentage</label>
                          <input
                              type="number"
                              className="login-input mt-1"
                              name="profit_percentage_sell"
                              value={profit_percentage_sell}
                              onChange={handleChange}
                              min = "0"
                            />
                            {profit_percentage_sellValidate == true ? (
                                <p className="errorcss">
                                {" "}
                                {validationnErr.profit_percentage_sell}{" "}
                                </p>
                            ) : (
                                ""
                            )}
                        </div>

                        <div className="input-settings">
                          <label>DCA Sell Profit Callback</label>
                          <input
                              type="number"
                              className="login-input mt-1"
                              name="profit_callback"
                              value={profit_callback}
                              onChange={handleChange}
                              min = "0"
                            />
                            {profit_callbackValidate == true ? (
                                <p className="errorcss">
                                {" "}
                                {validationnErr.profit_callback}{" "}
                                </p>
                            ) : (
                                ""
                            )}
                        </div>

                        <div className="input-settings">
                          <label>DCA Level Count</label>
                          <input
                              type="number"
                              className="login-input mt-1"
                              name="levels_count"
                              value={levels_count}
                              onChange={handleChange}
                              min = "0"
                            />
                            {levels_countValidateref.current == true ? (
                                <p className="errorcss">
                                {" "}
                                {validationnErr.levels_count}{" "}
                                </p>
                            ) : (
                                ""
                            )}
                        </div>

                        <div className="input-settings">
                          <label>Balance Lock</label>
                          <input
                              type="number"
                              className="login-input mt-1"
                              name="balance_lock"
                              value={balance_lock}
                              onChange={handleChange}
                              min = "0"
                            />
                            {balance_lockValidateref.current == true ? (
                                <p className="errorcss">
                                {" "}
                                {validationnErr.balance_lock}{" "}
                                </p>
                            ) : (
                                ""
                            )}
                        </div>

                        <div className="input-settings">
                        <label>Status</label>
                        <select
                            className="login-input mt-1"
                            name="status"
                            value={status}
                            onChange={handleChange}>
                            <option value="">Select Status</option>
                            <option value="Active">Active</option>
                            <option value="DeActive">DeActive</option>
                        </select>
                        {statusValidateref.current == true ? (
                            <p className="errorcss">
                            {" "}
                            {validationnErr.status}{" "}
                            </p>
                        ) : (
                            ""
                        )}
                        </div>

                        <div>
                        
                        {buttonLoader == false ? (
                        <button className="login-submit-btn mt-4" onClick={formSubmit}>
                            <span className="login-submit">Submit</span>
                        </button>
                        ) : (
                        <button className="login-submit-btn mt-4">
                            <span className="login-submit">Loading</span>
                        </button>
                        )}
                    
                        
                        </div>
                        
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

    
    </div>
  );
}

export default InvestmentSettings;
